import WorkOrderCreated from "./WorkOrderCreated";
import WorkOrderCategory from "./WorkOrderCategory";
import TechnicianWorkOrder from "./TechnicianWorkOrder";
import LocationWorkOrder from "./LocationWorkOrder";
import BackLogPriority from "./BackLogPriority";
import BackLogCategory from "./BackLogCategory";
import WorkOrderByFault from "./WorkOrderByFault";
import TopChart from "./TopChart";
import { Card, CardBody, CardHeader } from "../../../components/card/card";
import React, { useEffect } from "react";
import Moment from "moment/moment";
import "bootstrap-daterangepicker/daterangepicker.css";
import { useState } from "react";
import { analytics } from "../../../api";
import { DateRange } from "../../../components/DateRange";
import { endOfDay, startOfDay, subMonths } from "date-fns";
import { LocationFilter } from "../../../components/LocationFilter/index.jsx";
import ModalAISummary from "./ModalAISummary";
import workOrderByFault from "./WorkOrderByFault";
function capitalizeFirstWord(str) {
  if (!str) {
    return ""; // Handle empty strings
  }
  str = str.toLowerCase();
  return str.charAt(0).toUpperCase() + str.slice(1);
}
function Team({ locationId }) {
  const [allWo, setAllWo] = useState([]);
  const [topAsset, setTopAsset] = useState([]);
  const [topDuration, setTopDuration] = useState([]);
  const [topFault, setTopFault] = useState([]);
  const [topCategory, setTopCategory] = useState([]);

  const [completedWoPerDay, setCompletedWoPerDay] = useState([]);
  const [totalCompletedWo, setTotalCompletedWo] = useState(0);
  const [workOrderCreated, setWorkOrderCreated] = useState([]);
  const [workOrderCategory, setWorkOrderCategory] = useState([]);
  const [technicianWorkOrder, setTechnicianWorkOrder] = useState([]);
  const [technicianAllWorkOrder, setTechnicianAllWorkOrder] = useState([]);
  const [locationWorkOrder, setLocationWorkOrder] = useState([]);
  const [backLogByPriority, setBackLogByPriority] = useState([]);
  const [backLogByCategory, setBackLogByCategory] = useState([]);
  const [woByFault, setWoByFault] = useState([]);
  const [faults, setFaults] = useState([]);
  const [location_id, setLocation_id] = useState(locationId);
  const [selectedFault, setSelectedFault] = useState("");
  const [open, setOpen] = useState(false);
  // change start date to last week
  const [date, setDate] = useState({
    startDate: subMonths(new Date(), 1),
    endDate: new Date(),
  });

  const fetchData = async () => {
    try {
      const res = await analytics.getTeamAnalytics({
        fault: selectedFault,
        location_id: locationId,
        start_date: date.startDate
          ? Moment(date.startDate).format("YYYY-MM-DD")
          : null,
        end_date: date.startDate
          ? Moment(date.endDate).format("YYYY-MM-DD [23:59:59]")
          : null,
      });
      if (res.ok) {
        const body = await res.json();
        const data = body.data;
        // group completed Work Order by Day
        const all = data.all_wo;
        const completedPerDay = [];
        const createdPerDay = [];
        const categoriesWithTotalPerDay = [];
        const completedPerTechnicianPerDay = [];
        const allPerTechnician = [];
        const completedPerLocationPerDay = [];
        const workOrderByPriority = [];
        const backlogByCategory = [];
        const woByFault = [];
        const woDuration = [];
        const woPerAsset = [];
        all.forEach((wo) => {
          // group by category and day
          const category = wo.category?.name || 'No Category';
          const day = Moment(wo.start_date).format("YYYY-MM-DD");
          const foundCategory = categoriesWithTotalPerDay.find(
            (item) => item.category === category
          );
          if (foundCategory) {
            const foundDay = foundCategory.data.find(
              (item) => item.day === day
            );
            foundCategory.count += 1;
            if (foundDay) {
              foundDay.count += 1;
            } else {
              foundCategory.data.push({
                day,
                count: 1,
              });
            }
          } else {
            categoriesWithTotalPerDay.push({
              count: 1,
              category,
              data: [
                {
                  day,
                  count: 1,
                },
              ],
            });
          }
          // group by technician
          const technician = wo.assigned_to_user?.username || "Unassigned";
          const foundTechnician = allPerTechnician.find(
            (item) => item.username === technician
          );
          if (foundTechnician) {
            foundTechnician.count += 1;
          } else {
            allPerTechnician.push({
              count: 1,
              username: technician,
              firstname: wo.assigned_to_user?.firstname || "Unassigned",
              lastname: wo.assigned_to_user?.lastname || "Unassigned",
            });
          }
          // Group by Asset
          const assetId = wo.asset?.id;
          if (assetId) {
            const foundAsset = woPerAsset.find(
              (item) => item.asset_id === assetId
            );
            if (foundAsset) {
              foundAsset.count += 1;
            } else {
              woPerAsset.push({
                count: 1,
                asset_id: assetId,
                asset_name: wo.asset?.asset_name || "No Asset",
              });
            }
          }

          // add duration to woDuration from start_date to completed_date in minutes
          if (wo.status === "Completed" && wo.completed_date) {
            const startDate = Moment(wo.start_date);
            const completedDate = Moment(wo.completed_date);
            const duration = completedDate.diff(startDate, "minutes");
            // add formatted duration in Days Hour Minute
            const days = Math.floor(duration / 1440);
            const hours = Math.floor((duration % 1440) / 60);
            const minutes = duration % 60;
            const formattedDuration = `${days ? days + "d" : ""} ${hours ? hours + "h" : ""
              } ${minutes}m`;
            woDuration.push({
              title: wo.title,
              asset_id: assetId,
              asset_name: wo.asset?.asset_name || "No Asset",
              formattedDuration,
              duration,
            });
          }

          // completed mean status = "Completed"
          if (wo.status === "Completed") {
            const day = Moment(wo.start_date).format("YYYY-MM-DD");
            const found = completedPerDay.find((item) => item.day === day);
            if (found) {
              found.count += 1;
            } else {
              completedPerDay.push({
                day,
                count: 1,
              });
            }
            // group by technician
            const technician = wo.assigned_to_user?.username || "Unassigned";
            const foundTechnician = completedPerTechnicianPerDay.find(
              (item) => item.username === technician
            );
            if (foundTechnician) {
              foundTechnician.count += 1;
            } else {
              completedPerTechnicianPerDay.push({
                count: 1,
                username: technician,
                firstname: wo.assigned_to_user?.firstname || "Unassigned",
                lastname: wo.assigned_to_user?.lastname || "Unassigned",
              });
            }
            // group by location
            const location = wo.asset?.location?.id || wo.location?.id;
            const foundLocation = completedPerLocationPerDay.find(
              (item) => item.location === location
            );
            if (foundLocation) {
              const foundDay = foundLocation.data.find(
                (item) => item.day === day
              );
              foundLocation.count += 1;
              if (foundDay) {
                foundDay.count += 1;
              } else {
                foundLocation.data.push({
                  day,
                  count: 1,
                });
              }
            } else {
              completedPerLocationPerDay.push({
                count: 1,
                location: location,
                location_name: wo.asset?.location?.location_name || wo.location?.location_name || "Unassigned",
                data: [
                  {
                    day,
                    count: 1,
                  },
                ],
              });
            }
          }
          // group by fault
          const fault = capitalizeFirstWord(wo.fault);
          const foundFault = woByFault.find((item) => item.fault === fault);
          if (foundFault) {
            foundFault.count += 1;
          } else {
            woByFault.push({
              count: 1,
              fault,
            });
          }

          //all work order
          const priority = wo.priority;
          const foundPriority = workOrderByPriority.find(
            (item) => item.priority === priority
          );
          if (foundPriority) {
            foundPriority.count += 1;
          } else {
            workOrderByPriority.push({
              count: 1,
              priority,
            });
          }

          const categoryAll = wo.category?.name || 'No Category';
          const foundCategoryAll = backlogByCategory.find(
            (item) => item.category === categoryAll
          );
          if (foundCategoryAll) {
            foundCategoryAll.count += 1;
          } else {
            backlogByCategory.push({
              count: 1,
              category,
            });
          }
          // is for all work order no mather the status
          const found = createdPerDay.find((item) => item.day === day);
          if (found) {
            found.count += 1;
          } else {
            createdPerDay.push({
              day,
              count: 1,
            });
          }
        });
        console.log({ allWo, woDuration, woByFault, categoriesWithTotalPerDay })
        // sort duration descending
        woDuration.sort((a, b) => b.duration - a.duration);
        // sort asset by count descending
        woPerAsset.sort((a, b) => b.count - a.count);
        // sort categoriesWithTotalPerDay
        categoriesWithTotalPerDay.sort((a, b) => b.count - a.count);
        // sort woByFault
        woByFault.sort((a, b) => b.count - a.count);
        // only take the top 5 asset
        const top5Asset = woPerAsset.slice(0, 5);
        setTopAsset(top5Asset);
        // only take the top 5 duration
        const top5Duration = woDuration.slice(0, 5);
        setTopDuration(top5Duration);
        //only take the top 5 category
        const top5Category = categoriesWithTotalPerDay.slice(0, 5);
        setTopCategory(top5Category);
        // only take the top 5 fault
        const top5Fault = woByFault.slice(0, 5);
        setTopFault(top5Fault);
        // only
        setWoByFault(woByFault);
        setWorkOrderCreated(createdPerDay);
        setCompletedWoPerDay(completedPerDay);
        setWorkOrderCategory(categoriesWithTotalPerDay);
        setTechnicianWorkOrder(completedPerTechnicianPerDay);
        setTechnicianAllWorkOrder(allPerTechnician);
        setLocationWorkOrder(completedPerLocationPerDay);
        setBackLogByPriority(workOrderByPriority);
        setBackLogByCategory(backlogByCategory);

        // Total Completed WOrk order
        const totalCompleted = all.filter(
          (wo) => wo.status === "Completed"
        ).length;
        setTotalCompletedWo(totalCompleted);
        setAllWo(all);
      }
    } catch (e) {
      console.error(e);
    }
  };
  const getFaults = async () => {
    try {
      const res = await analytics.getFaults();
      if (res.ok) {
        const body = await res.json();
        const data = body.data;
        data.forEach((item) => {
          item.label = capitalizeFirstWord(item.fault);
        });
        setFaults(data);
      }
    } catch (e) {
      console.error(e);
    }
  };
  useEffect(() => {
    getFaults();
  }, []);
  useEffect(() => {
    fetchData();
  }, [date, locationId, selectedFault]);
  const handleChangeDate = (startDate, endDate) => {
    setDate({
      startDate,
      endDate,
    });
  };
  const [query, setQuery] = useState({ company: true });
  const handleChangeLocationFilter = (location_id) => {
    setQuery((prev) => ({
      ...prev,
      location_id: location_id ? location_id : "",
    }));
  };

  return (
    <div>
      <ModalAISummary
        openModal={open}
        setOpenModal={setOpen}
        data={{
          topAsset,
          topFault,
          topCategory,
          topDuration,
        }}
      ></ModalAISummary>
      <div className="row mb-3">
        <div className="col-12 col-md-3">
          <DateRange
            onChange={handleChangeDate}
            startDate={date.startDate}
            endDate={date.endDate}
          />
        </div>
        <div className="col-12 col-md-3">
          <LocationFilter onChange={handleChangeLocationFilter} />
        </div>
        <div className="col-12 col-md-3">
          <select
            className={"btn btn-outline-theme w-100"}
            value={selectedFault}
            onChange={(e) => setSelectedFault(e.target.value)}
          >
            <option value="">- Select Fault -</option>
            {faults.map((i) => (
              <option value={i.fault}>{i.label}</option>
            ))}
          </select>
        </div>
        <div className="col-12 col-md-3">
          <button
            className="btn btn-theme text-black"
            onClick={() => setOpen(true)}
          >
            {" "}
            <i class="fa fa-brain"></i> Summary by AI
          </button>
        </div>
      </div>
      <div className="row">
        <div className="col-12 col-md-6">
          <h4>Work Order By Status</h4>
          <TopChart data={allWo}></TopChart>
        </div>
        <div className="col-12 col-md-6">
          <h4>Work Order By Technician</h4>
          <Card>
            <CardBody>
              <div className="d-flex align-items-center mb-2"></div>
              <div>
                <div className="fs-12px fw-bold mb-2 text-inverse text-opacity-50">
                  Number of Work Order
                </div>
                <div className="chart mb-2" style={{ minHeight: "250px" }}>
                  <TechnicianWorkOrder
                    dataSource={technicianAllWorkOrder}
                  ></TechnicianWorkOrder>
                </div>
              </div>
            </CardBody>
          </Card>
        </div>
      </div>
      <div className="row mt-5">
        <div className="col-6">
          <h4>Completed Work Orders By Technicians</h4>
          <Card>
            <CardBody>
              <div>
                <div className="fs-12px fw-bold mb-2 text-inverse text-opacity-50">
                  Number of Work Order
                </div>
                <div className="chart mb-2" style={{ minHeight: "250px" }}>
                  <TechnicianWorkOrder
                    dataSource={technicianWorkOrder}
                  ></TechnicianWorkOrder>
                </div>
              </div>
            </CardBody>
          </Card>
        </div>
        <div className="col-6">
          <h4>Work Order By Category</h4>
          <Card>
            <CardBody>
              <div className="d-flex align-items-center mb-2"></div>
              <div>
                <div className="fs-12px fw-bold mb-2 text-inverse text-opacity-50">
                  Number of Work Order
                </div>
                <div className="chart mb-2" style={{ minHeight: "250px" }}>
                  <WorkOrderCategory
                    dataSource={workOrderCategory}
                  ></WorkOrderCategory>
                </div>
              </div>
            </CardBody>
          </Card>
        </div>
        <div className="col-6">
          <h4 style={{ marginTop: "20px" }}>Work Order By Fault</h4>
          <Card>
            <CardBody>
              <div className="d-flex align-items-center mb-2"></div>
              <div>
                <div className="fs-12px fw-bold mb-2 text-inverse text-opacity-50">
                  Number of Work Order
                </div>
                <div className="chart mb-2" style={{ minHeight: "250px" }}>
                  <WorkOrderByFault dataSource={woByFault}></WorkOrderByFault>
                </div>
              </div>
            </CardBody>
          </Card>
        </div>
      </div>
      <div className="row mt-5">
        <h4>Work Order</h4>
        <div className="col-6">
          <BackLogPriority dataSource={backLogByPriority}></BackLogPriority>
        </div>
        <div className="col-6">
          <BackLogCategory dataSource={backLogByCategory}></BackLogCategory>
        </div>
      </div>
    </div>
  );
}

export default Team;
